
export default new class ReceivedOrder {
    constructor() {
        // Order record in received orders list
        this.order = '.js-receivedOrder';
        this.status = '.js-statusButton';
        this.disabledClass = '_disabled';
        this.returnMany = '.js-returnButton';
        this.bepaidPay = '.js-bepaidButton';
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        // Click on order to view it
        $(document).on('click', this.order, (e) => {

            let $orderWrap = $(e.target).closest('.received-order__summary_wrap');

            // If record has not class (flag) _viewed send ajax to update this flag on the order
            if(!$orderWrap.hasClass('_viewed')){
                this.userOrderView($orderWrap);
            }
        });

        // Click on button to change status
        $(document).on('click', this.status, (e) => {
            if ($(e.target).hasClass(this.disabledClass)) {
                return false;
            }

            e.stopPropagation();
            e.preventDefault();
            
            let changeStatus = $(e.target).attr('data-change-status');
            let order_id = $(e.target).closest('.received-order').find('.js-receivedOrder').attr('data-order-id');
            $.request('OrderList::onStatusUpdate', {
                data: {
                    'order_id': order_id,
                    'change_status': changeStatus,
                    'status': $('.catalog-search__radio-group input:checked').val()
                },
                update: {'order_list': '._order-list-wrapper', 'order_count': '._order-list-count'},
                loading: '.js-preloaderOverlay',
            });
        });


        $(document).on('click', this.returnMany, (e) => {

            e.stopPropagation();
            e.preventDefault();

            let changeStatus = $(e.target).attr('data-change-status');
            let order_id = $(e.target).closest('.received-order').find('.js-receivedOrder').attr('data-order-id');
            $.request('OrderList::onReturn', {
                data: {
                    'order_id': order_id,
                    'change_status': changeStatus,
                },
                update: {'order_list': '._order-list-wrapper', 'order_count': '._order-list-count'},
                loading: '.js-preloaderOverlay',
            });
        });

    }



    // Ajax to update _viewed flag on viewed order
    userOrderView($order) {
        // Get order id
        let order_id = $order.attr('data-order-id');

        $order.addClass('_viewed');
        
        $.request('OrderList::onUserView', {
            data: {'order_id': order_id},
        });
    }
};



// WEBPACK FOOTER //
// ./src/common/modules/received-order/received-order.js